/**
 * Short-text problem input.
 */
import React, { useEffect, useState } from "react";

import CorrectAnswerCard from "./CorrectAnswerCard";
import WrongAnswerCard from "./WrongAnswerCard";
import RenderResponsePrompt from "./RenderResponsePrompt";

/**
 * Text input that compares the learner answer to the correct string.
 *
 * @param {{ tag: Element, onSetAnswer?: Function }} props
 */
export default function StringResponseRender(props) {
  const { tag, grade, onSetAnswer, isShowMark, setShowMark } = props;

  const [inputValue, setInputValue] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);

  useEffect(() => {
    if (!tag) return;
    setCorrectAnswer(tag.getAttribute("answer") || "");
  }, [tag]);

  /**
   * Grades the typed string and reports the answer.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} e Change event.
   * @returns {void}
   */
  const onChange = (e) => {
    setShowMark(false);

    const val = e.target.value;
    setInputValue(val);

    const correct = val === correctAnswer.toString();

    onSetAnswer({
      id: grade?.id,
      student_answer: val,
      correctness: correct ? "correct" : "incorrect",
    });

    setIsCorrect(correct);
  };

  return (
    <div className="mb-2">
      {/* NEW */}
      <RenderResponsePrompt tag={tag} />

      <input type="text" value={inputValue} onChange={onChange} className="form-control" />

      {isShowMark && (isCorrect ? <CorrectAnswerCard /> : <WrongAnswerCard />)}
    </div>
  );
}
